import { collection, query, where, onSnapshot, Firestore } from 'firebase/firestore';
import {sliceIntoChunks} from 'src/utils';
import * as _ from 'lodash';
import { checkedFishType } from '../model';

interface allListType {
  [key:string]:any[]
}
export const fishesPreloader = async (db:Firestore,allNames:string[],checkedFruit:checkedFishType,setCheckedFruit:React.Dispatch<React.SetStateAction<checkedFishType>>)=>{

  const namesArrSliceIn10 = sliceIntoChunks(allNames,10);
  let allList:allListType = {};

  // allNames.forEach((name)=>{
  //   allList = {...allList,[name.toLowerCase().trim()]:null};
  // });
  const setCheckedFruitListUpdateAllList = (alllist:allListType)=>{
    return (fishes:any)=>{
      allList = {...allList,...fishes};
      // console.log('alllist ',checkedFruit,allList);
      setCheckedFruit({...checkedFruit,...allList});
    };
  };
 
  await namesArrSliceIn10.forEach(async (tenFruitNames,idx) => {
  
    await fishesPreloaderPer10Snapshot(db,tenFruitNames,setCheckedFruitListUpdateAllList(allList));
    // console.log(`Fruit patch ${idx} is ready`);
    // return numFruit;
  });
  // console.log('waiting done');
};
export const fishesPreloaderPer10Snapshot = (db:Firestore,tenNames:string[],setCheckedFruitList:(fishes:any)=>void)=>{

  const tenFishesName = tenNames.map(name=>name.toLowerCase().trim());

  const q = query(collection(db, 'fishes'), where('name', 'in', tenFishesName));
  const unsubscribe = onSnapshot(q, (querySnapshot) => {
    let fishes: any[] = [];
    querySnapshot.forEach((doc) => {
      fishes = [...fishes, {...doc.data(),id:doc.id}];
    });
    let baseObj = {};
    tenFishesName.forEach((name:string)=>{
      baseObj = {...baseObj,[name]:[]};
    });
   
    setCheckedFruitList( {...baseObj,..._.groupBy(fishes,'name')});
  });
};
